import { render } from "./FormOption.vue?vue&type=template&id=56de944c"
import script from "./FormOption.vue?vue&type=script&lang=js"
export * from "./FormOption.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__